import React, { Component } from 'react';
import { Button, cls } from "../../../../packages/components";
import Translator from '../../../../requests/apa/Translator';
import Assets from '../../../../requests/apa/Asset';
import DeviceStorage from '../../../DeviceStorage/DeviceStorage';

class ButtonActualizar extends Component {
    constructor(props) {
        super(props);
        const region = DeviceStorage.getItem("region");
        this.buttonOnDefault = Assets.get('LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_Actualizar_On', '');
        this.buttonOn = Assets.get(`LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_Actualizar_On_${region}`, '') || this.buttonOnDefault;
        this.buttonOffDefault = Assets.get('LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_Actualizar_Off', '');
        this.buttonOff = Assets.get(`LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_Actualizar_Off_${region}`, '') || this.buttonOffDefault;

        this.state = {
            imageOnError: false,
            imageOffError: false,
            focus: false
        }
    }

    render(){
        const { imageOnError, imageOffError, focus } = this.state;
        const { buttonOn, buttonOff, buttonOnDefault, buttonOffDefault } = this;
        const { goToLastPage } = this.props

        return <Button 
                    type="button"
                    variant="primary"
                    className={cls(
                        `focusable`,
                        'btn',
                        `btn-actualizar`
                    )}
                    onClick={goToLastPage}
                    onFocus={() => this.setState({focus: true})}
                    onBlur={() => this.setState({focus: false})}

                >
                    <img src={imageOnError ? buttonOnDefault : buttonOn} 
                        onError={imageOnError ? () => {} : () => {
                            this.setState({imageOnError: true})
                        }}
                        style={{display: !focus ? "none" : "block"}}
                    />
                    <img src={imageOffError ? buttonOffDefault : buttonOff} 
                        onError={imageOffError ? () => {} : () => {
                            this.setState({imageOffError: true})
                        }}
                        style={{display: focus ? "none" : "block"}}
                    />
                </Button>
    }
}
   

export default ButtonActualizar;



// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPageSTB/buttons/ButtonActualizar.jsx